import { LocationResource } from "models/Resources/LocationResource";
import { LocationResponse } from "models/Responses/LocationResponse";
import { Location as Location } from "store/Slices/locationSlice";

export function transformLocationResponseToResource(
  locationResponse: LocationResponse[]
): LocationResource {
  const locationResource: LocationResource = {
    locations: [] as Location[],
  };

  locationResponse.forEach(element => {
    const location: Location = {
      name: element.mag_nom,
      storeNb: element.mag_num,
    };
    locationResource.locations.push(location);
  });
  return locationResource;
}
